import { getDeletePopup } from "../../../view/popup/PopupContainer";
import { removeComplianceList } from "../../ruleService";
import { ModalTypes } from "../TargetTypeManagement";
import { showDangerToast, showSuccessToast } from "../../../validation/ToastContainer";

export class ComplianceManager {

    constructor(setModalProps, setModalType, setShowModal, setPopup, elements) {
        this.setShowProps = setModalProps;
        this.setModalType = setModalType;
        this.setShowModal = setShowModal;
        this.setPopup = setPopup;
        this.elements = elements;
    }

    showAddModal = () => {
        this.setModalType(ModalTypes.CREATE);
        this.setShowModal(true);
    }

    showEditModal = () => {
        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;

        const modalProps = {
            title: "Edit Compliance",
            text: "Select Compliance",
            elements: this.elements,
            onClick: (element) => {
                setModalProps({ selectedCompliance: element })
                setModalType(ModalTypes.EDIT);
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.SELECT);
        setShowModal(true);

    }

    showRemoveModal = () => {
        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;
        const setPopup = this.setPopup;

        const modalProps = {
            title: "Remove Compliance",
            text: "Select Compliance",
            elements: this.elements,
            onSubmit: (compliance) => {
                setPopup(
                    getDeletePopup('Are you sure you want to remove the selected compliance records?',
                        'Remove Compliance',
                        () => removeComplianceList(compliance)
                            .then((errors) => {
                                setShowModal(false);
                                if (errors.length > 0) {
                                    errors.forEach(errMessage => {
                                        showDangerToast(errMessage, "Error", "Unable to delete Compliance");
                                    })
                                } else {
                                    showSuccessToast("Compliance were removed", "Remove Compliance")
                                }
                            }),
                        undefined,
                        'Remove Compliance'
                    ))
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.REMOVE);
        setShowModal(true);

    }

}
